<div class="inicio">
    <form #insertForm="ngForm"  [formGroup]="formDetSolicitud" >

        <p class="titulo">SOLICITUD DE {{tipoSolicitud}} </p>
          <div class="grid-containerB" >
            <button mat-mini-fab style="background-color: #00c030d0;  color: white;" (click)="goBack()"> <span class="material-icons">undo</span> </button>
          </div>
        <div class="grid-container2">
          <div class="celda">
              <mat-label class="label" >Tipo de solicitud</mat-label>
              <mat-form-field appearance="outline">
                  <input matInput type="text" placeholder="Tipo se solicitud" formControlName="tipoSolicitud" readonly/>
              </mat-form-field>
          </div>
        </div>
        <!--DATOS DEL COLABORADOR-->
        <p></p><h3>DATOS DEL COLABORADOR</h3>
        <div class="div" >
           <!--Nombre del colaborador-->
           <div class="grid-container">
            <div class="celda">
                <mat-label class="label"> Nombre del colaborador </mat-label>
                <mat-form-field appearance="outline">
                    <input matInput type="text" placeholder="Nombre del colaborador" formControlName="colaborador" readonly/>
                </mat-form-field>
            </div>
           </div>
          <!--Cargo y sucursal/oficina-->
          <div class="grid-container2">
            <!--Cargo-->
            <div class="celda">
                <mat-label class="label"> Cargo </mat-label>
                <mat-form-field appearance="outline">
                  <input matInput type="text" placeholder="No se encontró este campo" formControlName="puesto" readonly/>
                </mat-form-field>
            </div>

            <!--Oficina/Sucursal-->
            <div class="celda">
                <mat-label class="label"> Sucursal </mat-label>
                <mat-form-field appearance="outline">
                    <input matInput type="text" placeholder="No se encontró este campo" formControlName="sucursal"readonly />
                </mat-form-field>
            </div>
          </div>
        </div>
        <p></p>
        <div class="div">

          <!--Cargo y sucursal/oficina-->
          <P></P>
            <!--Cargo-->
            <div class="celda">
                <mat-label class="label"> Cargo a cubrir </mat-label>
                <mat-form-field appearance="outline">
                  <input matInput type="text" placeholder="No se encontró este campo" formControlName="puesto_a_cubrir" readonly/>
                </mat-form-field>
            </div>

            <!--Oficina/Sucursal-->
            <div class="celda">
                <mat-label class="label"> Sucursal a cubrir </mat-label>
                <mat-form-field appearance="outline">
                <input matInput type="text" placeholder="No se encontró este campo" formControlName="sucursal_a_cubrir" readonly/>
                </mat-form-field>
            </div>

        </div>
         <!--DATOS DEL SOLICITANTE-->
         <p></p><h3>DATOS DEL SOLICITANTE</h3>
         <div class="div">
            <!--Nombre del colaborador-->
            <div class="grid-container">
             <div class="celda">
                 <mat-label class="label"> Nombre del solicitante </mat-label>
                 <mat-form-field appearance="outline">
                     <input matInput type="text" placeholder="No se encontró este campo" formControlName="solicitante" readonly/>
                 </mat-form-field>
             </div>
            </div>
           <!--Cargo y sucursal/oficina-->
           <div class="grid-container2">
             <!--Cargo-->
             <div class="celda">
                 <mat-label class="label"> Cargo </mat-label>
                 <mat-form-field appearance="outline">
                   <input matInput type="text" placeholder="No se encontró este campo" formControlName="puesto_solicitante" readonly/>
                 </mat-form-field>
             </div>

             <!--Oficina/Sucursal-->
             <div class="celda">
                 <mat-label class="label"> Sucursal </mat-label>
                 <mat-form-field appearance="outline">
                     <input matInput type="text" placeholder="No se encontró este campo" formControlName="sucursal_solicitante"readonly />
                 </mat-form-field>
             </div>
           </div>
            <!--email-->
            <div class="grid-container"  >
             <div class="celda"   >
                 <mat-label class="label"> Email </mat-label>
                 <mat-form-field appearance="outline">
                   <input matInput type="text" placeholder="No se encontró este campo" formControlName="email_solicitante"readonly/>
                 </mat-form-field>
             </div>
           </div>
         </div>

         <!--DATOS GNERALES DE LOS PRIVILEGIOS-->
         <p></p><h3>DATOS GENERALES</h3>
        <div class="div"  >
          <!--
          <div class="grid-container" *ngIf=" statusSolicitud=='Espera' && banderaE !='true'" >
                <--SERVICIOS ACTIVADOS EN LA SUCURSAL QUE CORRESPONDE, CON LOS QUE YA CUENTA EL COLABORADOR--
            <mat-label class="grid-container" class="label"  > SERVICIOS ACTIVADOS CON LOS QUE CUENTA EL COLABORADOR EN LA SUCURSAL CORRESPONDIENTE</mat-label>

            <table mat-table [dataSource] = "dataActivados"  class="mat-elevation-z8" class="tableServiciosActivados" >                                                              >

              <ng-container matColumnDef="c1">
                  <th mat-header-cell *matHeaderCellDef mat-sort-header> NOMBRE DEL SERVICIO </th>
                  <td mat-cell *matCellDef="let element"> {{element.detalle_solicitud.tipo_servicio.nombre_servicio}} </td>
              </ng-container>
              <ng-container matColumnDef="c2">
                <th mat-header-cell *matHeaderCellDef mat-sort-header> USUARIO </th>
                <td mat-cell *matCellDef="let element"> {{element.usuario}}</td>

              </ng-container>
              <ng-container matColumnDef="c3">
                <th mat-header-cell *matHeaderCellDef mat-sort-header> PASSWORD </th>
                <td mat-cell *matCellDef="let element"> {{element.contrasenia}}  </td>
              </ng-container>
              <ng-container matColumnDef="c4">
                <th mat-header-cell *matHeaderCellDef mat-sort-header> SUCURSAL </th>
                <td mat-cell *matCellDef="let element"> {{sucursal_cubrir}} </td>
              </ng-container>

              <tr mat-header-row *matHeaderRowDef="encabezadostabla4"></tr>
              <tr mat-row *matRowDef="let row; columns: encabezadostabla4;"></tr>
              <h2></h2>
            </table>
            <br>
          </div>
          -->
         <div class="div">
           <!--TABLAS DE SERVICIOS SOLICITADOS-->
            <div  class="grid-container" *ngIf=" statusSolicitud=='Espera' && banderaE !='true'" >
                <div class="grid-container2" *ngIf="this.dataVacia()==true" >
                  <div  class="celda"  >
                    <mat-label class="label"> AGREGAR SERVICIOS </mat-label>
                    <mat-form-field appearance="fill">
                      <mat-label > Seleccione los servicios que requiera </mat-label>
                      <mat-select formControlName="tipo_servicio" multiple  >
                        <mat-option *ngFor="let servicio of listaServicios" [value]="servicio">{{servicio.nombre_servicio}}</mat-option>
                      </mat-select>
                    </mat-form-field>
                  </div>

                  <div class="celda" class="wrapper" >
                    <button type="submit" mat-raised-button color="primary" style="background-color: #00d836d0; width:350px; height:50px; color: white;"  (click)="generarDetalleSolicitudAlta()" >Añadir servicios</button>
                  </div>
                </div>


                <p></p>


              <!--TABLA PARA ACTIVACION------------------------------------------------------------------------->
              <div class="grid-container"  *ngIf="statusSolicitud=='Espera' && banderaE!='true' ">
                <mat-label class="grid-container" class="label"  > SERVICIOS PARA ACTIVACIÓN DE PRIVILEGIOS</mat-label>

                <table mat-table [dataSource] = "dataSourceAcSus"  class="mat-elevation-z8">

                  <ng-container matColumnDef="c1">
                      <th mat-header-cell *matHeaderCellDef mat-sort-header> NOMBRE DEL SERVICIO </th>
                      <td mat-cell *matCellDef="let element"> {{element.detalleSolicitud.tipo_servicio.nombre_servicio}} </td>
                  </ng-container>
                  <ng-container matColumnDef="c2">
                    <th mat-header-cell *matHeaderCellDef mat-sort-header> USUARIO </th>
                    <td mat-cell *matCellDef="let element"> {{element.usuario}}</td>

                  </ng-container>
                  <ng-container matColumnDef="c3">
                    <th mat-header-cell *matHeaderCellDef mat-sort-header> PASSWORD </th>
                    <td mat-cell *matCellDef="let element"> {{element.contrasenia}}  </td>
                  </ng-container>
                  <!--Selección de las sucursales-->
                  <ng-container matColumnDef="c4">
                    <th mat-header-cell *matHeaderCellDef mat-sort-header>  SELECCIONE LA(S) SUCURSAL(ES) </th>
                    <td mat-cell *matCellDef="let element">
                      <mat-form-field appearance="fill">
                        <mat-label > Seleccione la o las sucursales </mat-label>
                        <mat-select [(ngModel)]="element.sucursales" [ngModelOptions]="{standalone: true}" multiple>
                          <mat-option *ngFor="let sucursal of listaSucursales" [value]="sucursal">{{sucursal.nombreSucursal}}</mat-option>
                        </mat-select>
                      </mat-form-field>
                    </td>
                  </ng-container>
                  <!--Visualización de las sucursales seleccionadas-->
                  <ng-container matColumnDef="c5">
                    <th mat-header-cell *matHeaderCellDef mat-sort-header> LISTA DE SUCURSALES </th>
                    <td mat-cell *matCellDef="let element"> {{this.leerSucursales(element.sucursales)}}</td>
                  </ng-container>
                  <ng-container matColumnDef="c6">
                    <th mat-header-cell *matHeaderCellDef mat-sort-header> {{cabeceraCheck}} SERVICIO </th>
                    <td mat-cell *matCellDef="let element">
                        <mat-checkbox [(ngModel)]="element.status_reg" [ngModelOptions]="{standalone: true}"  ></mat-checkbox>
                        <span *ngIf="element.status_reg==true" ></span>
                    </td>
                  </ng-container>
                  <tr mat-header-row *matHeaderRowDef="encabezadostabla6"></tr>
                  <tr mat-row *matRowDef="let row; columns: encabezadostabla6;"></tr>
                  <h2></h2>
                </table>
                <br>
                <!--Servicio agregados para DAR DE ALTA servicios-->
                <mat-label class="grid-container" class="label" > SERVICIOS A DAR DE ALTA PARA ACTIVACIÓN </mat-label>

                <table mat-table [dataSource] = "dataSource" class="wrapper" class="mat-elevation-z8">

                  <ng-container matColumnDef="c1">
                      <th mat-header-cell *matHeaderCellDef mat-sort-header> NOMBRE DEL SERVICIO </th>
                      <td mat-cell *matCellDef="let element"> {{element.nombre_servicio}} </td>
                  </ng-container>
                  <ng-container matColumnDef="c2">
                    <th mat-header-cell *matHeaderCellDef mat-sort-header> USUARIO </th>
                    <td mat-cell *matCellDef="let element">
                      <mat-form-field>
                        <mat-label>Ingrese el usuario</mat-label>
                        <input matInput (keydown.space)="$event.preventDefault();"  [(ngModel)]="element.usuario"  [ngModelOptions]="{standalone: true}" pattern="{{element.expresionRegular}}" >
                      </mat-form-field>
                    </td>
                  </ng-container>
                  <ng-container matColumnDef="c3">
                    <th mat-header-cell *matHeaderCellDef mat-sort-header> PASSWORD </th>
                    <td mat-cell *matCellDef="let element">
                      <mat-form-field>
                        <mat-label>Ingrese la contraseña</mat-label>
                        <input matInput (keydown.space)="$event.preventDefault();" [(ngModel)]="element.contrasenia" [ngModelOptions]="{standalone: true}" >
                      </mat-form-field>
                    </td>
                  </ng-container>
                  <!--Selección de las sucursales-->
                  <ng-container matColumnDef="c4">
                    <th mat-header-cell *matHeaderCellDef mat-sort-header> ASIGNAR SUCURSAL </th>
                    <td mat-cell *matCellDef="let element">
                      <mat-form-field appearance="fill">
                        <mat-label > Seleccione la o las sucursales </mat-label>
                        <mat-select [(ngModel)]="element.sucursales" [ngModelOptions]="{standalone: true}" multiple>
                          <mat-option *ngFor="let sucursal of listaSucursales" [value]="sucursal">{{sucursal.nombreSucursal}}</mat-option>
                        </mat-select>
                      </mat-form-field>
                    </td>
                  </ng-container>
                  <!--Visualización de las sucursales seleccionadas-->
                  <ng-container matColumnDef="c5">
                    <th mat-header-cell *matHeaderCellDef mat-sort-header> LISTA DE SUCURSALES </th>
                    <td mat-cell *matCellDef="let element"> {{this.leerSucursales(element.sucursales)}}</td>
                  </ng-container>
                  <ng-container matColumnDef="c6">
                    <th mat-header-cell *matHeaderCellDef mat-sort-header> {{cabeceraCheck}} SERVICIO </th>
                    <td mat-cell *matCellDef="let element">
                        <mat-checkbox [(ngModel)]="element.status_reg" [ngModelOptions]="{standalone: true}"  ></mat-checkbox>
                        <span *ngIf="element.status_reg==true" ></span>
                    </td>
                  </ng-container>


                  <tr mat-header-row *matHeaderRowDef="encabezadostabla6"></tr>
                  <tr mat-row *matRowDef="let row; columns: encabezadostabla6;"></tr>
                  <h2></h2>

                </table>
              </div>
              <br><br>
            </div> <!--CIERRE DE LAS TABLAS DE SERVICIOS SOLICITADOS-->


          <!--TABLA DE SERVICIOS ACTIVADOS, SOLICITUD ANTENDIDA-->
        <div class="grid-tabla" *ngIf="statusSolicitud=='Atendido' " >
          <mat-label class="grid-container" class="label"  > SERVICIOS ACTIVADOS DE ESTA SOLICITUD</mat-label>
          <table mat-table [dataSource] = "dataServAct"  class="mat-elevation-z8">

            <ng-container matColumnDef="c1">
                <th mat-header-cell *matHeaderCellDef mat-sort-header> NOMBRE DEL SERVICIO </th>
                <td mat-cell *matCellDef="let element"> {{element.detalleSolicitud.tipo_servicio.nombre_servicio}} </td>
            </ng-container>
            <ng-container matColumnDef="c2">
              <th mat-header-cell *matHeaderCellDef mat-sort-header> USUARIO </th>
              <td mat-cell *matCellDef="let element"> {{element.usuario}}</td>

            </ng-container>
            <ng-container matColumnDef="c3">
              <th mat-header-cell *matHeaderCellDef mat-sort-header> PASSWORD </th>
              <td mat-cell *matCellDef="let element"> {{element.contrasenia}}  </td>
            </ng-container>
            <ng-container matColumnDef="c4">
              <th mat-header-cell *matHeaderCellDef mat-sort-header> SUCURSAL </th>
              <td mat-cell *matCellDef="let element"> {{element.nomSucursalCol}} </td>
            </ng-container>

            <tr mat-header-row *matHeaderRowDef="encabezadostabla4"></tr>
            <tr mat-row *matRowDef="let row; columns: encabezadostabla4;"></tr>
            <h2></h2>
          </table>
          <br>
        </div>

            <br>
              <div class="grid-container">
                <mat-label class="label">Tipo</mat-label>
                  <mat-form-field appearance="outline">
                    <input matInput type="text" placeholder="Temporal o permanente" formControlName="tipo" readonly/>
                  </mat-form-field>
              </div>
              <p></p><p></p>
              <div class="grid-container" *ngIf="tipoSeleccionado('Temporal'); ">
                <mat-label class="label"> Fecha de alta - Fecha de baja </mat-label>
                <mat-form-field appearance="fill">
                  <mat-label> Fecha de alta - Fecha de baja </mat-label>
                  <mat-date-range-input [formGroup]="range" >
                    <input matStartDate formControlName="fecha_alta" placeholder="Start date" readonly >
                    <input matEndDate formControlName="fecha_baja" placeholder="End date" readonly>
                  </mat-date-range-input>
                </mat-form-field>
              </div>

            <!--Comentarios-->
            <div class="grid-container">
                <div class="celda">
                    <mat-label class="label" >Comentarios</mat-label>
                    <mat-form-field class="example-full-width" appearance="outline"  >
                        <textarea matInput placeholder="Comentarios" formControlName="comentarios" readonly ></textarea>
                    </mat-form-field>
                </div>
            </div>
          </div>
        </div>
        <p></p>
        <!--Botones-->
        <div class="grid-container2" *ngIf="statusSolicitud=='Espera' && banderaE !='true'">
          <!--Boton guaradar-->
          <button  type="submit" mat-raised-button color="primary"  (click)="generarAltaActServicio()" >Aceptar</button>
          <!--Boton cancelar-->
          <button mat-raised-button color="warn" (click)="rechazarSolicitud()" >Rechazar solicitud<mat-icon>cancel</mat-icon></button>
        </div>
        <div class="wrapper" *ngIf="statusSolicitud=='Atendido' || statusSolicitud=='Cancelado' || banderaE=='true'  " >
          <button mat-raised-button style="background-color: #00c030d0; width:350px; color: white;" (click)="goBack()" >Aceptar<mat-icon>done_all</mat-icon></button>
        </div>

    </form>
  </div>

